module.exports = __webpack_public_path__ + "static/img/public_qr_code.597a9bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/public_qr_code.jpg
// module id = Lg0d
// module chunks = 23